export enum SensorType {
	Temperature,
	Humidity,
}
